import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useBankListFromAfterbanks } from "./Afterbanks.hook"
import { getTarjetaBancariaById } from "./TarjetaBancaria.service"

interface UseTarjetaBancariaProps {
  bankDetailsFilterId?: string
}

export const useTarjetaBancaria = ({
  bankDetailsFilterId,
}: UseTarjetaBancariaProps) => {
  const queryClient = useQueryClient()
  const { bankList } = useBankListFromAfterbanks()

  const {
    data: tarjetaDetail,
    isLoading: tarjetaDetailIsLoading,
    refetch: tarjetaDetailRefetch,
    isFetching: tarjetaDetailIsFetching,
  } = useQuery({
    queryKey: ["getTarjetaBancariaById", bankDetailsFilterId],

    queryFn: () =>
      bankDetailsFilterId ? getTarjetaBancariaById(bankDetailsFilterId) : null,
    refetchOnWindowFocus: true,
    retry: false,
    select: (data) => {
      const logo = bankList?.find(
        (bank) => bank?.service === data?.service
      )?.image
      return {
        ...data,
        logo,
      }
    },
  })

  const tarjetaDetailInvalidation = ({ id }: { id?: string }) => {
    return queryClient.invalidateQueries({
      queryKey: ["getTarjetaBancariaById", id],
    })
  }

  return {
    tarjetaDetail,
    tarjetaDetailIsLoading,
    tarjetaDetailRefetch,
    tarjetaDetailInvalidation,
    tarjetaDetailIsFetching,
  }
}
